import { createAction, props } from "@ngrx/store";
import { PLUGIN } from "src/app/common/enums/plugins";
import { SLOT } from "src/app/common/enums/slot";

export const navigateToSlot = createAction("[Router] Navigate to slot by name", props<{ slot: SLOT }>());

export const navigateToPlugin = createAction("[Router] Navigate to plugins", props<{ id: PLUGIN }>());
